import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AdminBarcodeScannerService {
  public lock(orientation: any) {
    //fake lock function
  }

  public unlock() {
    //fake unlock function
  }

  public isTorchAvailable(): Promise<{ available: boolean }> {
    //fake isTorchAvailable function

    return new Promise((resolve, reject) => {
      resolve({ available: false });
    });
  }

  public toggleTorch(): void {
    //fake toggleTorch function
  }

  public addListener(
    listener: string,
    listenerFunc: (event: any) => void,
  ): Promise<PluginListenerHandle> {
    //fake addListener function
    return new Promise((resolve, reject) => {
      resolve({
        remove: () => {
          return new Promise<void>((resolveRemove) => {
            resolveRemove();
          });
        },
      });
    });
  }

  public async requestPermissions() {
    //fake requestPermissions function
  }

  public async startScan(options: any) {
    //fake startScan function
  }

  public async stopScan() {
    //fake stopScan function
  }

  public getStartScanOptions() {
    //fake getStartScanOptions function

    return {
      formats: null,
      lensFacing: null,
    };
  }
}

export interface PluginListenerHandle {
  //fake interface
  remove: () => Promise<void>;
}
